<template>
    <a-drawer title="关联子任务"
              placement="right"
              :width="windowWidth >= 800 ? 800 : '95%'"
              :visible="visible"
              @close="close()">

        <template #extra>
            <a-button type="primary"
                      html-type="submit"
                      :disabled="task.selectedRowKeys.length <= 0 || loadings"
                      @click="submit">关联</a-button>
        </template>

        <a-row class="n-p-1">
            <a-input-search v-model:value="keyword"
                            class="n-col-3 n-mb-3"
                            placeholder="请输入关键字进行搜索"
                            @search="getTask" />
        </a-row>

        <a-spin :spinning="loadings">
            <a-table :dataSource="task.datas"
                     :columns="task.columns"
                     :row-selection="{ fixed: true, selectedRowKeys: task.selectedRowKeys, onChange: onSelectChange }"
                     :bordered="true"
                     :scroll="{ x: 1000 }"
                     :loading="task.loading"
                     :pagination="false"
                     tableLayout="fixed"
                     size="small"
                     @change="tableChange">
                <template #bodyCell="{ column, record }">
                    <template v-if="column.key == 'level'">
                        <a-row align="middle"
                               :gutter="[5]">
                            <a-col><i class="c-level"
                                   :class="'c-level-' + record.level"></i></a-col>
                            <a-col>{{ getLevel(record.level).title }}</a-col>
                        </a-row>
                    </template>

                    <template v-if="column.key == 'status'">
                        <a-row align="middle"
                               :gutter="[5]">
                            <a-col>
                                <i class="n-icon n-icon-size-20 c-status"
                                   :class="getStatus(record.status).icon"></i>
                            </a-col>
                            <a-col class="n-f-2">{{ getStatus(record.status).title }}</a-col>
                        </a-row>
                    </template>
                </template>
            </a-table>
        </a-spin>
    </a-drawer>
</template>
<script >
    import { mapMutations, mapState } from 'vuex';
    import nui from '@/assets/script';

    export default nui.extend(true, {}, nui.extendVue, {
        name: 'LinkTaskBox',
        props: {
            visible: { type: Boolean, default: false },
            projectId: Number,
            parentId: Number
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),

        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loadings: false,

                keyword: '',

                task: {
                    loading: false,
                    datas: [],
                    columns: [
                        { title: '项目标题', dataIndex: 'title', key: 'title', width: 250 },
                        { title: '优先级', dataIndex: 'level', key: 'level', width: 90 },
                        { title: '状态', dataIndex: 'status', key: 'status', width: 60 },
                        { title: '负责人', dataIndex: 'charge', key: 'charge', width: 120 },
                        { title: '截止日期', dataIndex: 'end', key: 'end', width: 90 }
                    ],
                    selectedRowKeys: []
                }
            })
        },
        watch: {
            visible: function () {
                // 避免外部添加数据，每次打开都重新获取一下
                if (this.visible) {
                    this.getTask()
                }
            },
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize'])),

            NMounted () {
            },
            /**
             * @description 获取项目
             */
            getTask () {
                this.task.loading = true;

                this.request(this.API.relativeEnable, {
                    method: 'post',
                    data: {
                        projectId: this.projectId,
                        taskName: this.keyword
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        res.data = res.data.map(item => {
                            item.principalList = item.principalList.map(sItem => sItem.userName);
                            return item
                        })

                        res.data = res.data.filter(item => item.taskId != this.parentId)

                        this.task.datas = this.formatTaskData(res.data, false)
                        this.task.loading = false;
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            onSelectChange (selectedRowKeys) {
                this.task.selectedRowKeys = selectedRowKeys
            },
            close () {
                this.reset()
            },
            reset () {
                this.task.selectedRowKeys = [];
                this.task.datas = [];
                this.$emit('close')
            },
            /**
             * @description 关联
             */
            submit () {
                this.loadings = true

                this.request(this.API.toggleSubTask, {
                    method: 'post',
                    data: { subTaskIdList: this.task.selectedRowKeys, parentId: this.parentId }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.success('关联成功')
                        this.$emit('success')
                        this.$emit('close')

                        this.loadings = false
                    } else {
                        this.error(res.msg)
                    }
                })

            },
        }),
        components: {
        },
        ...nui.extendVue.extendLife
    })
</script>
<style lang="scss">
</style>